import { render, staticRenderFns } from "./CoachIndex.vue?vue&type=template&id=06ced6a4&scoped=true&"
import script from "./CoachIndex.vue?vue&type=script&lang=js&"
export * from "./CoachIndex.vue?vue&type=script&lang=js&"
import style0 from "./CoachIndex.vue?vue&type=style&index=0&id=06ced6a4&lang=stylus&scoped=true&"
import style1 from "./CoachIndex.vue?vue&type=style&index=1&id=06ced6a4&lang=stylus&scoped=true&"
import style2 from "./CoachIndex.vue?vue&type=style&index=2&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ced6a4",
  null
  
)

export default component.exports